import { Box } from '@mui/material';

import { usePageTitle } from '../../hooks/usePageTitle';
import { DatenschutzContent } from './DatenschutzContent';

export const DatenschutzPage = () => {
  usePageTitle('Datenschutz');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        gap: 2,
        paddingY: 2,
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ flexGrow: 1, minHeight: 0 }}>
        <DatenschutzContent />
      </Box>
    </Box>
  );
};
